import React from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import '../styles/pages/Legal.scss';

const Terms = () => {
    return (
        <div className="legal-page">
            <Navbar />
            <main className="legal-content">
                <h1>Terms of Service</h1>
                <p className="legal-updated">Last updated: August 2026</p>

                <p>
                    By creating an account or using YeniDers, you agree to these terms. Please
                    read them carefully.
                </p>

                <h2>Using YeniDers</h2>
                <ul>
                    <li>You must provide accurate information when creating your account.</li>
                    <li>You are responsible for keeping your password secure.</li>
                    <li>You must be the owner of, or have permission to share, any material you upload.</li>
                    <li>You may not upload content that infringes copyright, is unlawful, or is abusive.</li>
                </ul>

                <h2>Your content</h2>
                <p>
                    You retain ownership of the notes and materials you upload. By uploading, you
                    grant YeniDers a license to host, display, and distribute that content to
                    other users of the platform as part of the service.
                </p>

                <h2>AI tools</h2>
                <p>
                    Features such as summaries, quizzes, and explanations are generated
                    automatically and may occasionally be inaccurate or incomplete. Use your own
                    judgement when relying on AI-generated results for studying.
                </p>

                <h2>Account suspension</h2>
                <p>
                    We may suspend or terminate accounts that violate these terms, misuse the
                    platform, or infringe on the rights of others.
                </p>

                <h2>Changes to these terms</h2>
                <p>
                    We may update these terms from time to time. Continued use of YeniDers after
                    changes take effect means you accept the updated terms.
                </p>

                <h2>Contact</h2>
                <p>
                    Questions about these terms? Reach out through our Contact page.
                </p>
            </main>
            <Footer />
        </div>
    );
};

export default Terms;
